import { render } from "./AddNewUser.vue?vue&type=template&id=2e0c9401&scoped=true&lang=pug"
import script from "./AddNewUser.vue?vue&type=script&lang=js"
export * from "./AddNewUser.vue?vue&type=script&lang=js"

import "./AddNewUser.vue?vue&type=style&index=0&id=2e0c9401&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0c9401"]])

export default __exports__